import {getEventAvatar, getEventAvatarThumbnail} from "@spoferan/spoferan-ts-core";
import {EventStatus, isPublicEventStatus} from "@spoferan/spoferan-ts-core";
import {mapState, mapActions} from 'pinia'
import {useEventStore} from "../store/event";

export default {

    computed: {
        ...mapState(useEventStore, {
            event: state => state.event,
            authPermissions: state => state.authPermissions,
            eventShareText: state => state.eventShareText,
        }),

        isFinished() {
            return this.$date().isSameOrAfter(this.event.end_date) && this.event.status.value !== EventStatus.Canceled
        },

        isPublished() {
            return [EventStatus.Published, EventStatus.Canceled].indexOf(this.event.status.value) > -1
        },

        isPublic() {
            return isPublicEventStatus(this.event.status.value)
        },

        eventThumbnail() {
            return getEventAvatarThumbnail(this.event)
        },

        eventAvatar() {
            return getEventAvatar(this.event)
        },

        isParticipant() {
            return !!this.authPermissions?.is_participant
        }
    },

    methods: {
        ...mapActions(useEventStore, [
            'replaceEventData',
            'setEventAuthPermissionsProps',
            'refreshAuthPermissions',
        ]),

        hasActivePage(pageType) {
            return this.event?.pages?.length && this.event.pages.find(page => page.id === pageType)
        }
    }

}
